import Routes from './routes'
import ReducerFuncs from './store'

const Reducers = (reducerObj) => { reducerObj.variants = ReducerFuncs }

export {
  Routes,
  Reducers
}
